import ApiService from './ApiService';

class MasterDataApi extends ApiService {
    constructor() {
        super('master-data');
    }

    async getAll() {
        return this.get('');
    }
}

export default new MasterDataApi();
